import { Directive, HostListener, inject, Injectable, input } from '@angular/core';
import { AutopropBackend } from 'app/shared/backend';

type Event = StrataReportsClickedEventType | LayerToggledEventType | RpdPurchaseOpenEventType

interface StrataReportsClickedEventType {
    eventType: 'STRATA_REPORTS_CLICKED'
    upid: string
}

interface LayerToggledEventType {
    eventType: 'LAYER_TOGGLED'
    layerKey: string
    enabled: boolean
}

interface RpdPurchaseOpenEventType {
    eventType: 'RPD_PURCHASE_OPEN'
    rpdId: string,
    rpdProjectName: string,
    rpdAddress: string,
}


@Directive({
    selector: '[logEvent]',
})
export class LogEventDirective {

    logEventEnabled = input(true);

    logEvent = input.required<Event>();

    private logEventService = inject(LogEventService);

    @HostListener('click')
    onClick() {
        if(this.logEventEnabled()) {
            this.logEventService.logEvent(this.logEvent());
        }
    }
}

@Injectable({
    providedIn: 'root'
})
export class LogEventService {
    private backendService = inject(AutopropBackend);

    logEvent(event: Event) {
        this.backendService.post('/api/log-event', { event: event })
            .subscribe();
    }
}
